import {connect} from 'react-redux';
import ClearCartConfirmationModal from 'shared/ClearCartConfirmationModal.jsx';
import {cancelReservation} from './actions';
import {displayClearCartConfirmation} from './actionTypes';

const mapStateToProps = state => ({
  visible: state.admin.review.showClearCartConfirmation
});

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(displayClearCartConfirmation(false)),
  onContinueClick: () => dispatch(cancelReservation())
});

export default connect(mapStateToProps, mapDispatchToProps)(ClearCartConfirmationModal);



// WEBPACK FOOTER //
// ./src/features/admin/review/ClearCartConfirmationContainer.jsx